<template>
  <div class="recentTimePage">
    <div class="recentContent flex-center">
      <div
        class="recentContent-item"
        :class="[index == currentIndex && 'active']"
        v-for="(item, index) in recentList"
        :key="item.value"
        @click="selectType(item, index)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number | String,
    },
    recentList: {
      type: Array,
      default: () => [
        {
          label: "近30天",
          value: 30,
          day:30,
        },
        {
          label: "近90天",
          value: 90,
          day:90,
        },
        {
          label: "近180天",
          value: 180,
          day:180,
        },
        {
          label: "近1年",
          value: 365,
          day:365,
        },
      ],
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          let defaultIndex = this.recentList.findIndex(
            (item) => item.value == this.value
          );
          if (defaultIndex != -1) {
            this.currentIndex = defaultIndex;
          }
        });
      },
      immediate: true,
    },
  },
  mounted() {
    // this.$nextTick(() => {
    //   let defaultIndex = this.recentList.findIndex(
    //     (item) => item.value == this.value
    //   );
    //   if (defaultIndex != -1) {
    //     this.currentIndex = defaultIndex;
    //   }
    // });
  },
  methods: {
    selectType(item, index) {
      this.currentIndex = index;
      this.$emit("update:value", item.value);
      this.$emit("change", item.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-center {
  display: flex;
  align-items: center;
}
:deep(.recent-time) {
  width: 240px;
  margin-left: 8px;
}
.recentContent {
  &-item {
    background: #fff;
    border: 1px solid #efefef;
    padding: 5px 11px;
    color: #666;
    border-radius: 4px;
    min-width: 60px;
    text-align: center;
    letter-spacing: 0.2px;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    font-weight: 400;
    line-height: 1.5715;
    white-space: nowrap;
    outline: none;
    cursor: pointer;
    transition: all 0.1s cubic-bezier(0, 0, 1, 1);
    -webkit-appearance: none;
    -webkit-user-select: none;
    user-select: none;
    font-size: 12px;
  }
  &-item:hover {
    opacity: 0.8;
  }
  &-item:not(:first-child) {
    margin-left: 8px;
  }
  &-item:last-child {
    margin-right: 8px;
  }
  .active {
    background: #fff !important;
    border: 1px solid #3159ff !important;
    padding: 5px 11px !important;
    color: #3159ff !important;
    opacity: 1 !important;
  }
}
</style>
